import React, { FC } from 'react';
import { useReframe } from 'nike-re-framejs';
import i18n from '../../../common/i18n';
import BetLocationContext, { betLocation } from '../../../../src/common/BetLocationContext';
import { dispatch } from 'nike-re-framejs';
import { setTop10ActiveTab, top10LiveMatchesLoaded, top10PrematchMatchesLoaded } from '../handlers';
import { top10ActiveTab$, top10LiveBets$, top10LiveMatches$, top10PrematchBets$, top10PrematchMatches$ } from '../subs';
import { useFetchMatchesFromTopEvents, useFetchTopLive } from '../hooks';
import { TOP10_LIVE_TAB, TOP10_PREMATCH_TAB } from '../constants';
import { setInfocentrumFromTab } from '../../turboLive/push/overview/handlers';
import { useScoreboardTypes } from '../../turboLive/hooks/useScoreboardTypes';
import { isMobileChannel } from '../../../common/util';
import NuiBox from '../../nui-box/NuiBox';
import NuiTitle from '../../nui-title/NuiTitle';
import SportsFilter from '../../common/SportsFilter';
import HomepageTab from './HomepageTab';

const HomepageTop10: FC<{ children }> = ({ children }) =>
    isMobileChannel() ? (
        <>
            <NuiTitle title="10 NAJ TIPOV" />
            <HomepageTop10View>{children}</HomepageTop10View>
        </>
    ) : (
        <NuiBox noPad otherClass="overflow-hidden mt-30">
            <HomepageTop10View>{children}</HomepageTop10View>
        </NuiBox>
    );

const HomepageTop10View: FC<{ children }> = ({ children }) => {
    const { subscribe, derefSub } = useReframe();
    const activeTab = subscribe(top10ActiveTab$) || TOP10_PREMATCH_TAB;
    const top10PrematchBets = derefSub(top10PrematchBets$);
    const top10PrematchMatches = derefSub(top10PrematchMatches$);
    const top10LiveBets = derefSub(top10LiveBets$);
    const top10LiveMatches = derefSub(top10LiveMatches$);
    useFetchTopLive(activeTab);
    useFetchMatchesFromTopEvents(top10PrematchMatchesLoaded, top10PrematchBets$, top10PrematchMatches$);
    useFetchMatchesFromTopEvents(top10LiveMatchesLoaded, top10LiveBets$, top10LiveMatches$);
    useScoreboardTypes();
    const activePrematchTab = activeTab === TOP10_PREMATCH_TAB;
    const betPosition = activePrematchTab ? betLocation.HP_10NAJ_PREMATCH : betLocation.HP_10NAJ_LIVE;
    return (
        <>
            <SportsFilter>
                <HomepageTab
                    label="NAJ 10"
                    active={activePrematchTab}
                    onClick={() => {
                        dispatch(setTop10ActiveTab(TOP10_PREMATCH_TAB));
                        dispatch(setInfocentrumFromTab(top10PrematchBets, top10PrematchMatches));
                    }}
                />
                <HomepageTab
                    label="NAJ 10 Live"
                    active={activeTab === TOP10_LIVE_TAB}
                    onClick={() => {
                        dispatch(setTop10ActiveTab(TOP10_LIVE_TAB));
                        dispatch(setInfocentrumFromTab(top10LiveBets, top10LiveMatches));
                    }}
                />
            </SportsFilter>
            <BetLocationContext.Provider value={{ betLocationSection: betPosition }}>
                {children}
            </BetLocationContext.Provider>
            {activePrematchTab && (
                <a
                    href="/komunita/top-podujatia"
                    className={`text-center d-block py-10 ${
                        isMobileChannel()
                            ? 'c-white bg-light-burgundy mb-10 pb-30'
                            : 'c-link-default br-t-default-light'
                    }`}
                >
                    {i18n('nui.hp.naj10.more')}
                </a>
            )}
        </>
    );
};

export default HomepageTop10;
